import { useCallback, useRef } from "react";

/*
Returns a function reference that doesnt change when implementation changes.
 */
export function useStaticCallback<T>(fn: T): T {
  const ref = useRef<any>(fn);
  ref.current = fn;
  return useCallback((...args: any[]) => ref.current(...args), []) as any;
}
